import React, { useState } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
// Asegúrate de tener instalado 'bootstrap' y 'react-bootstrap'.
// Y de importar los estilos CSS en tu proyecto principal, por ejemplo en App.js o index.js:
// import 'bootstrap/dist/css/bootstrap.min.css';
// import 'bootstrap-icons/font/bootstrap-icons.css'; // ¡Importante para los íconos!

function StarRatingComponent({onSet}) {
  const maxStars = 5;

  // --- Estados para las calificaciones seleccionadas ---
  // ratingResultado guarda la calificación final seleccionada para "Calidad del resultado"
  const [ratingResultado, setRatingResultado] = useState(3); // Valor inicial de 3, como en tu imagen

  // ratingTiempo guarda la calificación final seleccionada para "Eficiencia de tiempo"
  const [ratingTiempo, setRatingTiempo] = useState(3); // Valor inicial de 3, como en tu imagen

  // --- Estados para el efecto hover (previsualización) ---
  // hoverResultado guarda la calificación que se está previsualizando al pasar el mouse
  const [hoverResultado, setHoverResultado] = useState(0); // 0 significa sin hover activo

  // hoverTiempo guarda la calificación que se está previsualizando al pasar el mouse
  const [hoverTiempo, setHoverTiempo] = useState(0); // 0 significa sin hover activo

  // --- Etiquetas descriptivas para cada nivel ---
  const resultadoLabels = {
    1: 'Muy mala',
    2: 'Menos de lo que esperaba',
    3: 'Normal',
    4: 'Mejor de lo que esperaba',
    5: 'Brutal!'
  };

  const tiempoLabels = {
    1: 'Nada',
    2: 'Poco',
    3: 'Normal',
    4: 'Mucho',
    5: 'Demasiado'
  };

  // --- Funciones para manejar eventos ---

  // Maneja el clic en una estrella para establecer la calificación final
  const handleStarClick = (category, ratingValue) => {
    if (category === 'resultado') {
      setRatingResultado(ratingValue);
    } else if (category === 'tiempo') {
      setRatingTiempo(ratingValue);
    }
  };

  // Maneja el mouse entrando en una estrella (efecto hover)
  const handleStarMouseEnter = (category, ratingValue) => {
    if (category === 'resultado') {
      setHoverResultado(ratingValue);
    } else if (category === 'tiempo') {
      setHoverTiempo(ratingValue);
    }
  };

  // Maneja el mouse saliendo del grupo de estrellas (quita el efecto hover)
  const handleStarMouseLeave = (category) => {
    if (category === 'resultado') {
      setHoverResultado(0); // Reinicia el hover
    } else if (category === 'tiempo') {
      setHoverTiempo(0); // Reinicia el hover
    }
  };

  // Maneja el envío del formulario (aquí puedes hacer lo que necesites con ratingResultado y ratingTiempo)
  const handleSubmit = () => {
   
    // Usamos 'confirm()' en lugar de 'alert()'
    if (window.confirm("Estas seguro de enviar tu calificación? No podrás cambiarla después.")) {
        onSet(ratingResultado, ratingTiempo);
    } else {
  
    }
  };

  // --- Función de renderizado para las estrellas ---
  const renderStars = (category, selectedRating, hoverRating) => {
    const stars = [];
    // La calificación a mostrar (sea la seleccionada o la de hover)
    const displayRating = hoverRating > 0 ? hoverRating : selectedRating;

    for (let i = 1; i <= maxStars; i++) {
      stars.push(
        <i
          key={i}
          className={`bi ${i <= displayRating ? 'bi-star-fill text-warning' : 'bi-star'} fs-3`}
          style={{ cursor: 'pointer', marginRight: '5px' }}
          onClick={() => handleStarClick(category, i)}
          onMouseEnter={() => handleStarMouseEnter(category, i)}
          // El onMouseLeave debe ir en el contenedor padre de las estrellas
          // para que el efecto se quite solo cuando el mouse sale de todas ellas,
          // no de cada estrella individual. Por eso lo ponemos en el div padre.
        ></i>
      );
    }
    return stars;
  };

  return (
    <Container className="p-4 border rounded shadow-sm" style={{ maxWidth: '500px' }}>
      <Row className="mb-4">
        <Col>
          <p className="fs-6 fw-semibold text-dark mb-3">La calidad del resultado fue:</p>
          <div
            onMouseLeave={() => handleStarMouseLeave('resultado')} // Aquí el onMouseLeave para el grupo
          >
            {renderStars('resultado', ratingResultado, hoverResultado)}
          </div>
          <p className="mt-2 text-center fw-bold text-primary" style={{ minHeight: '24px', fontSize: '1.1rem' }}>
            {resultadoLabels[hoverResultado > 0 ? hoverResultado : ratingResultado]}
          </p>
        </Col>
      </Row>

      <Row className="mb-4">
        <Col>
          <p className="fs-6 fw-semibold text-dark mb-3">Esta tarea contribuyo:</p>
          <div
            onMouseLeave={() => handleStarMouseLeave('tiempo')} // Aquí el onMouseLeave para el grupo
          >
            {renderStars('tiempo', ratingTiempo, hoverTiempo)}
          </div>
          <p className="mt-2 text-center fw-bold text-primary" style={{ minHeight: '24px', fontSize: '1.1rem' }}>
            {tiempoLabels[hoverTiempo > 0 ? hoverTiempo : ratingTiempo]}
          </p>
        </Col>
      </Row>

      <Row className="mt-4">
        <Col className="text-center">
          <Button
            variant="light"
            className="border text-secondary px-4 py-2"
            onClick={handleSubmit} // Llama a la función handleSubmit al hacer clic
          >
            Enviar
          </Button>
        </Col>
      </Row>
    </Container>
  );
}

export default StarRatingComponent;